module.exports = __webpack_public_path__ + "media/images/icons/mail-fb2afea548e5accc306ff55237eba229.svg";